import './ShareableLink.css';

import { useState } from 'react';
import { captureProductEvent, getCurrentScanSessionId } from '../utils/productAnalytics';

const ShareableLink = ({ sessionId }) => {
  const [copied, setCopied] = useState(false);
  const [showTooltip, setShowTooltip] = useState(false);

  const scanSessionId = getCurrentScanSessionId();
  const shareableUrl = sessionId
    ? `${window.location.origin}/share/${sessionId}${scanSessionId ? `?scanSessionId=${encodeURIComponent(scanSessionId)}` : ''}`
    : '';

  const handleCopyLink = async () => {
    if (!sessionId) return;

    captureProductEvent('menu-shared', { sessionId, shareMethod: 'copy_link' });

    try {
      await navigator.clipboard.writeText(shareableUrl);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    } catch (err) {
      // Fallback for older browsers
      const textArea = document.createElement('textarea');
      textArea.value = shareableUrl;
      document.body.appendChild(textArea);
      textArea.select();
      document.execCommand('copy');
      document.body.removeChild(textArea);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    }
  };

  const getButtonText = () => {
    if (copied) return '✓ Copied!';
    return '🔗 Share menu with others 📋';
  };

  const isDisabled = !sessionId || copied;

  return (
    <div className="shareable-link-simple" style={{ position: 'relative', display: 'inline-block' }}>
      <button
        className={`share-button ${copied ? 'copied' : ''} ${isDisabled ? 'disabled' : ''}`}
        onClick={handleCopyLink}
        disabled={isDisabled}
        onMouseEnter={() => sessionId && setShowTooltip(true)}
        onMouseLeave={() => setShowTooltip(false)}
      >
        {getButtonText()}
      </button>

      {showTooltip && sessionId && <div className="share-tooltip">{shareableUrl}</div>}
    </div>
  );
};

export default ShareableLink;
